import { FC } from "react";

import { t } from "i18n/i18n";

type ChatMentionToastProps = {
  authorName: string | null;
  messagePreview: string;
  onClick: () => void;
};

export const ChatMentionToast: FC<ChatMentionToastProps> = ({
  authorName,
  messagePreview,
  onClick,
}) => {
  return (
    <button className="w-full min-w-0 overflow-hidden text-left" type="button" onClick={onClick}>
      {authorName ? (
        <span className="flex min-w-0">
          <span className="truncate">{authorName}</span>
          <span className="shrink-0">&nbsp;{t("chat.mention_notification_action")}</span>
        </span>
      ) : (
        <span className="block truncate">{t("chat.mention_notification_unknown_author")}</span>
      )}
      <span className="block truncate">{messagePreview}</span>
    </button>
  );
};
